/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem,
    DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemFromJSON,
    DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemToJSON,
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem
 */
export interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem
     */
    list: Array<DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem>;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem
     */
    total: number;
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItemFromJSON(json: any): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem {
    return DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItemToJSON(value?: DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


